export const GET_DOMAIN = "GET_DOMAIN";
export const SET_DOMAIN = "SET_DOMAIN";
export const DELETE_DOMAIN = "DELETE_DOMAIN";
